import { HubConnectionBuilder, LogLevel } from '@microsoft/signalr';
import env from '../../environment.config';

export const createHubConnection = (hub) => new HubConnectionBuilder()
	.configureLogging(LogLevel.None)
	.withUrl(`${env.api_url}hubs/${hub}`)
	.withAutomaticReconnect()
	.build();
